import {XIcon} from '@primer/octicons-react'
import {Dialog, Heading, IconButton} from '@primer/react'
import {useRef} from 'react'

import {MergeBoxWithSuspense} from './MergeBox'
import type {Channels} from '../hooks/use-mergeability-live-updates'

interface MergeabilitySidesheetProps {
  mergeabilitySidesheetIsOpen: boolean
  toggleMergeabilitySidesheet: (isOpen: boolean) => void
  mergeStatusButtonRef: React.RefObject<HTMLButtonElement | null>
  viewerLogin: string
  helpUrl: string
  channels: Channels
}

/**
 * Renders the merge box in a sidesheet that is triggered from the header
 */
export function MergeabilitySidesheet({
  mergeabilitySidesheetIsOpen,
  toggleMergeabilitySidesheet,
  mergeStatusButtonRef,
  viewerLogin,
  helpUrl,
  channels,
}: MergeabilitySidesheetProps) {
  const closeButtonRef = useRef<HTMLButtonElement>(null)

  const exitOverlay = () => toggleMergeabilitySidesheet?.(false)
  if (!mergeabilitySidesheetIsOpen) {
    return null
  }

  return (
    <Dialog
      initialFocusRef={closeButtonRef}
      position={{narrow: 'fullscreen', regular: 'right', wide: 'right'}}
      returnFocusRef={mergeStatusButtonRef}
      onClose={exitOverlay}
      title="Merge status"
      renderHeader={() => (
        <Dialog.Header>
          <div className="d-flex flex-justify-between flex-items-center my-2 pr-mx-3">
            <Heading as="h3" className="f3 text-bold">
              Merge status
            </Heading>
            <IconButton
              ref={closeButtonRef}
              aria-label="Close merge status"
              icon={XIcon}
              variant="invisible"
              onClick={exitOverlay}
            />
          </div>
        </Dialog.Header>
      )}
    >
      <MergeBoxWithSuspense helpUrl={helpUrl} viewerLogin={viewerLogin} channels={channels} hideIcon />
    </Dialog>
  )
}
